<template lang="pug">
div
  div.header
    span.text-20-b Мои цели
    span.all.text-16-b( @click="openAllTask()" ) Все
  active-goal-block.active-goal( :goal="activeGoal" @editGoal="editGoal")
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import ProgressCircle from '../ProgressCircle.vue';
import ActiveGoalBlock from './ActiveGoalBlock.vue';
export default {
  name: 'GoalPanel',
  components: {
    ProgressCircle,
    ActiveGoalBlock
  },

  mounted() {
    if(!this.activeGoal) this.loadGoalList()
  },

  computed: {
    ...mapState('goals', ['activeGoal'])
  },

  methods: {
    ...mapActions('goals', ['loadGoalList']),
    ...mapMutations('goals', ['setSelectedGoal']),

    openAllTask() {
      this.$router.push(`/allGoals/${'all'}`)
    },

    editGoal(goal) {
      this.setSelectedGoal(goal)
      this.$router.push(`/addGoal/${goal.uuid}`)
    }
  }
}

</script>
<style scoped>
.header {
  width: 100%;
  padding: 16px 39px 16px 39px;
  display: flex;
  align-items: center;
}
.all {
  margin-left: auto;
  color:#5365E5;
}
.active-goal {
  margin-right: 18px;
  margin-left: 18px;
}
</style>
